import { Configuration } from '@omniflow/omni-webapi';
import { StorageKey } from '../enums/storage-key.enum';

export const WEBAPI_CONFIGURATION = new Configuration({
    basePath:
    'https://flowchartbuilder-api.annalect.com',
});

export const OKTA_AUTH_STATUS: { disabled: boolean; bearer: string | null } = {
    // You can disable Okta authentication locally
    disabled: true,
    // You can overwrite the bearer token with a manual bearer token (or null if you don't want to)
    bearer: null,
};

export const BEARER = localStorage.getItem(StorageKey.BearerToken);
export const OKTA_AUTH_CONFIG = {
    issuer: 'https://onewp.okta.com/oauth2/default',
    clientId: '0oan33qjj9hghOJd3357',
    redirectUri:
        'https://flowchartbuilder-exceladdin.annalect.com' +
        '/login/callback',
    scopes: ['openid', 'email', 'profile'],
};

export const TESTMODE_ENABLED = false;

export const OMNI_AUTH_CONFIG = {
        issuer: 'https://omni.annalect.com/extsso?resourcekey=omg_flowchartportal&redirecturl=https://flowchartbuilder-exceladdin.annalect.com/login/callback?applogin=true'
}